import React, { useMemo } from 'react'
import { ModalProvider, light, dark } from 'vvs-uikit'
import { Web3ReactProvider } from '@web3-react/core'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { useThemeManager } from 'state/user/hooks'
import { useConnectWeb3Account } from 'state/web3/account'
import { getLibrary } from 'utils/web3React'
import { LanguageProvider } from 'contexts/Localization'
import { ToastsProvider } from 'contexts/ToastsContext'
import store from 'state'
import XVvsProvider from 'views/xVvs/context/XVvsProvider'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import useActiveWeb3React from './hooks/useActiveWeb3React'
import { BLOCKED_ADDRESSES } from './config/constants'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failCount) => failCount < 5,
      refetchOnWindowFocus: false,
    },
  },
})

const ThemeProviderWrapper = (props) => {
  const [isDark] = useThemeManager()
  return <ThemeProvider theme={isDark ? dark : light} {...props} />
}

const Web3AccountConnection: React.FC = () => {
  useConnectWeb3Account()
  return null
}

const Blocklist: React.FC = ({ children }) => {
  const { account } = useActiveWeb3React()
  const blocked: boolean = useMemo(() => Boolean(account && BLOCKED_ADDRESSES.indexOf(account) !== -1), [account])
  if (blocked) {
    return <div>Blocked address</div>
  }
  return <>{children}</>
}

const RootProviders: React.FC = ({ children }) => {
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <Web3AccountConnection />

      <Blocklist>
        <Provider store={store}>
          <ToastsProvider>
            <HelmetProvider>
              <ThemeProviderWrapper>
                <LanguageProvider>
                  <QueryClientProvider client={queryClient}>
                    {children}
                    {process.env.REACT_APP_RELEASE_STAGE === 'development' && <ReactQueryDevtools />}
                  </QueryClientProvider>
                </LanguageProvider>
              </ThemeProviderWrapper>
            </HelmetProvider>
          </ToastsProvider>
        </Provider>
      </Blocklist>
    </Web3ReactProvider>
  )
}

export default RootProviders

export const VvsMainProviders: React.FC = ({ children }) => {
  return (
    <XVvsProvider>
      <ModalProvider>{children}</ModalProvider>
    </XVvsProvider>
  )
}

export const MinerMoleProviders: React.FC = ({ children }) => {
  return <ModalProvider>{children}</ModalProvider>
}

export const GotchiProviders: React.FC = ({ children }) => {
  return <ModalProvider>{children}</ModalProvider>
}
